import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { OrderService } from "../../services/order/order.service";
import { ProductAttributes } from "@models/product.model";
import { Location } from "@angular/common";
import { OrderItemAttributes } from "@models/orderItem.model";
import { UserService } from "../../services/user/user.service";
import { OrderAttributes } from "@models/order.model";
import { BaseReview } from "@models/review.model";
import { finalize } from "rxjs";

@Component({
    selector: "app-user-review-page",
    templateUrl: "./user-review-page.component.html",
    styleUrl: "./user-review-page.component.scss",
    standalone: false,
})
export class UserReviewPageComponent implements OnInit {
    private orderId!: string;
    public orderItems!: OrderItemAttributes[];
    public order!: OrderAttributes;
    private userId!: number;
    public isLoading: boolean = false;

    constructor(
        private route: ActivatedRoute,
        private orderService: OrderService,
        private location: Location,
        private router: Router,
        private userService: UserService,
    ) {}

    ngOnInit(): void {
        this.route.params.subscribe((params) => {
            this.orderId = params["orderId"];
            if (this.orderId) {
                this.loadOrderDetails();
                this.getUserId();
            }
        });
    }

    private loadOrderDetails(): void {
        this.isLoading = true;
        this.orderService
            .getOrderById(this.orderId)
            .pipe(
                finalize(() => {
                    this.isLoading = false;
                }),
            )
            .subscribe({
                next: (response) => {
                    if (response) {
                        this.order = response;
                        this.orderItems = response.orderItems?.map((orderItem) => orderItem)!;
                    }
                },
            });
    }

    public getUserId(): void {
        this.userService.getUserDetails().subscribe((response) => {
            if (response) {
                this.userId = response.id;
            }
        });
    }

    public isReviewDisabled(product: ProductAttributes | undefined): boolean {
        if (!this.order || !this.order.reviews) {
            return true;
        }

        return this.order.reviews.some(
            (review: BaseReview) => review.productId === product?.id && review.userId === this.userId,
        );
    }

    public goBack(): void {
        this.location.back();
    }

    public navigateRating(itemId: number): void {
        this.router.navigate([`/account/orders/${this.orderId}/itemsReview/${itemId}/review`]);
    }
}
